import "zod/compile";
import { oc } from "@orpc/contract";
import { z } from "zod";
import {
  Sd849OrgSettingsPatchSchema,
  Sd849OrgSettingsValuesSchema,
} from "@erp/shared-types";

/**
 * The organization-level 849 settings (SD-86): every switch and number in
 * `SD_849_ORG_SETTINGS`, read from and written to the store that owns it.
 *
 * `update` takes a PATCH — only the keys being changed, `null` to unset — and
 * never a whole document, so a save can never rewrite a key it did not mean to
 * from a stale or stripped read (#7291).
 */
const getContract = oc.output(Sd849OrgSettingsValuesSchema).route({
  method: "GET",
  summary: "Get the organization's 849 settings",
  description:
    "Returns the current value of each organization-level Ship & Debit 849 setting; an absent key is unset.",
});

const updateContract = oc
  .input(z.object({ patch: Sd849OrgSettingsPatchSchema }))
  .output(Sd849OrgSettingsValuesSchema)
  .route({
    summary: "Change some of the organization's 849 settings",
    description:
      "Applies only the given settings (null unsets one), leaving every other stored setting unchanged, and returns the settings as stored afterwards.",
  });

export const sd849OrgSettingsContracts = {
  get: getContract,
  update: updateContract,
};
